module.exports = __webpack_public_path__ + "static/media/archero2_page_area02_img_cn@2x.87112422.png";